import { withInstall } from '@vuesax-plus/utils'
import CheckboxGroup from './src/checkbox-group.vue'

export const VsCheckboxGroup = withInstall(CheckboxGroup)
export default VsCheckboxGroup

export * from './src/checkbox-group'
